export type PmView = 'list' | 'kanban' | 'gantt';

interface Props {
  value: PmView;
  onChange: (v: PmView) => void;
}

const OPTIONS: { value: PmView; label: string }[] = [
  { value: 'list',   label: 'List'   },
  { value: 'kanban', label: 'Kanban' },
  { value: 'gantt',  label: 'Gantt'  },
];

// Segmented control for switching between project views (list / kanban / gantt).
// Lives on the breadcrumb row above the project header so it's reachable
// without scrolling and never moves as the page below changes.
const ViewSelect: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className="pm-view-select" role="tablist" aria-label="Project view">
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            className={`pm-view-select-option ${active ? 'active' : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default ViewSelect;
